/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:00
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-12-09 10:29:27
 * @FilePath: /unifyxp-v2-store-portal/src/components/Layouts/Item/Item.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import React, { ReactNode } from 'react';
import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { titleGenerator } from 'src/tools/helper';
import css from './css.less';

interface IProps {
  title?: ReactNode | string;
  rightPart?: ReactNode | string;
  rightSubTitle?: ReactNode | string;
  bottomTitle?: ReactNode | string;
  titleContainerClassName?: string;
  children?: any;
  help?: string;
  validateStatus?: string;
  name?: string;
  rules?;
  containerClassName?;
  bottomTitleContainerClassName?;
  error?: boolean;
  errorText?: string;
  id?: string;
  belowComponentTitle?: ReactNode | string;
  errorClassName?: string;
  size?: string;
  titleClassName?: string;
}
const ItemWrapper = (props: IProps) => {
  const {
    containerClassName,
    children,
    titleContainerClassName,
    bottomTitleContainerClassName,
    title,
    rightPart,
    rightSubTitle,
    bottomTitle,
    error,
    errorText,
    id,
    belowComponentTitle,
    errorClassName,
    size: _s,
    titleClassName,
  } = props;
  const size = _s || 'middle';
  const _containerClassName = {
    small: css.smallContainer,
    middle: css.container,
  };

  return (
    <div
      className={`${_containerClassName[size]} ${containerClassName || ''}`}
      {...(id ? { id } : {})}
      data-tester-title={titleGenerator(title)}>
      {(title || rightSubTitle || rightPart) && (
        <div
          className={`${css.titleContainer} ${titleContainerClassName || ''}`}>
          <div className={css.mainTitleContainer}>
            <div className={css.upperTitleContainer}>
              {title && (
                <div className={`${css.title} ${titleClassName || ''}`}>
                  {title}
                </div>
              )}

              {rightSubTitle && (
                <div className={css.rightSubTitle}>{rightSubTitle}</div>
              )}
            </div>
            {bottomTitle && (
              <div
                className={
                  css.bottomTitleContainer +
                    ' ' +
                    bottomTitleContainerClassName || ''
                }>
                {bottomTitle}
              </div>
            )}
          </div>
          {rightPart && (
            <div className={css.rightPartContainer}>{rightPart}</div>
          )}
        </div>
      )}

      <ErrorBoundary>{children || null}</ErrorBoundary>
      {belowComponentTitle && (
        <div className={css.multiTip}>{belowComponentTitle}</div>
      )}
      {error && (
        <div className={`${css.errorContainer} ${errorClassName}`}>
          {errorText || getI18nFromGeneral('general.antd.DatePicker.item_help')}
        </div>
      )}
    </div>
  );
};
export default ItemWrapper;
